import { ChefHat, Coffee, Flame, UtensilsCrossed } from "lucide-react";
import { Reveal, Overline } from "@/components/Motion";
import { EXPERIENCE } from "@/data/content";

const ICONS = { ChefHat, Coffee, Flame, UtensilsCrossed };

const Experience = () => (
  <section className="bg-shell py-28 sm:py-36" data-testid="experience-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <Reveal>
        <Overline className="text-wine text-center">The Forco Amore Experience</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5 text-center">
          Crafted for the <span className="italic text-wine">Senses</span>
        </h2>
      </Reveal>

      <div className="mt-16 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {EXPERIENCE.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <Reveal key={item.title} delay={i * 0.12}>
              <div
                className="group h-full rounded-[1.75rem] border border-sand bg-cream p-9 hover:-translate-y-2 hover:border-wine/30 transition-all duration-500"
                data-testid={`experience-card-${i}`}
              >
                <div className="flex items-center justify-between">
                  <span className="flex h-14 w-14 items-center justify-center rounded-full border border-wine/25 text-wine group-hover:bg-wine group-hover:text-cream transition-colors duration-500">
                    <Icon size={22} strokeWidth={1.4} />
                  </span>
                  <span className="font-serif italic text-brass text-lg">0{i + 1}</span>
                </div>
                <h3 className="mt-8 font-serif text-2xl font-medium tracking-tight">{item.title}</h3>
                <p className="mt-3 text-faded text-sm font-light leading-relaxed">{item.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default Experience;
